// extracted by mini-css-extract-plugin
export var body = "_hx-0";
export var sectionHeader = "_hx-4";
export var shortcutColumns = "_hx-2";
export var shortcutList = "_hx-1";
export var shortcutSection = "_hx-3";